import { useDispatch, useSelector } from "react-redux";
import { Table } from "src/components";
import { companyActions } from "src/context/company-slice";
import { RootState } from "src/context/store";
import CompanyLayoutComponent from "./company-layout.component";
import { getCompanyMasterColumns } from "./company-master-table.columns";
import { useToast } from "src/hooks/useToast";
import { queryPriceIdentifierCompany } from "src/services/company-api";

const CompanyMasterComponent = () => {
  const { companyMasterTable } = useSelector((state: RootState) => state.company);

  const dispatch = useDispatch();
  const { toast } = useToast();

  //M10-9403
  const editHandler = async (rowData: any) => {
    try {
      const res = await queryPriceIdentifierCompany();

      if (res?.status !== 200 || !Array.isArray(res?.data?.data)) {
        throw new Error("Invalid response");
      }

      const priceIdentifier = res.data.data.map((item: any) => ({
        value: item.priceldentifier_id,
        label: item.description,
      }));

      const formData = {
        ...rowData,
        is_discount_display: rowData.is_discount_display === "Y" ? { value: "Y", label: "Yes" } : { value: "N", label: "No" },
        ewaybill_applicable: rowData.ewaybill_applicable === "Y" ? { value: "Y", label: "Yes" } : { value: "N", label: "No" },
        einv_applicable: rowData.einv_applicable === "Y" ? { value: "Y", label: "Yes" } : { value: "N", label: "No" },
        allow_placeOrder: rowData.allow_placeOrder === 1 ? { label: "Yes", value: 1 } : { label: "No", value: 0 },
        Price_Identifier_PO: priceIdentifier?.find((item: any) => item.value === rowData.Price_Identifier_PO) || null,
      };

      // Dispatch form data and open modal
      dispatch(companyActions.setAddEditFormData(formData));
      dispatch(companyActions.setIsEdit(true));
      dispatch(companyActions.setShowAddEditForm(true));
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while preparing the form.",
      });
      console.error("editHandler error:", error);
    }
  }; //M10-9403

  return (
    <CompanyLayoutComponent>
      <div>
        <Table title="Company details" showSearch={true} data={companyMasterTable || []} columns={getCompanyMasterColumns([], editHandler)} />
      </div>
    </CompanyLayoutComponent>
  );
};

export default CompanyMasterComponent;
